module.exports = __webpack_public_path__ + "img/tiff.784e1718.png";